var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-field-label"},[_c('span',{staticClass:"mall-field-label__text"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.required)?_c('img',{staticClass:"mall-field-label__essential",attrs:{"src":require("@/assets/mall/icn_star_essential.svg"),"alt":"필수"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ba7bf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/atoms/MallFieldLabel.vue
// module id = null
// module chunks = 